import { useId } from 'react'
import { Props_SnippetLinkBoxCarousel } from './LinkBoxCarousel.props'
import SnippetLink from '../Shared/Link/Link'
import SwiperControls, { swiperNavigationOptions } from '../Shared/SwiperControls/SwiperControls'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, A11y } from 'swiper/modules'
import { CompileHeadingToSpan } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetLinkBoxCarousel = (props: Props_SnippetLinkBoxCarousel) => {
    const { snippet, heading, repeatable_entry } = props

    const uniqueId = useId().replace(/:/g, '')
    const backgroundColorClass = `snippet-link-box-carousel--bg--${snippet.backgroundColor?.value}`

    return (
        <section className={`snippet-link-box-carousel ${backgroundColorClass}`}>
            <div className="snippet-link-box-carousel__container">
                <h2 className={`snippet-link-box-carousel__heading${!heading.visibility?.value ? ' accessible-heading' : ''}`}>
                    {CompileHeadingToSpan(heading.content.value!)}
                </h2>
                <div className="snippet-link-box-carousel__container-swiper">
                    <SwiperControls
                        uniqueId={uniqueId}
                        showNavigationMobile={true}
                        showNavigationDesktop={true}
                        showPaginationMobile={false}
                        showPaginationDesktop={false}
                        navigationPosition="sides"
                        navigationSidesPosition="inside"
                        className="snippet-link-box-carousel__swiper-controls"
                    />
                    <Swiper
                        className="snippet-link-box-carousel__container-slides"
                        modules={[Navigation, A11y]}
                        navigation={{
                            ...swiperNavigationOptions,
                            prevEl: `.swiper-controls__button--prev-${uniqueId}`,
                            nextEl: `.swiper-controls__button--next-${uniqueId}`,
                        }}
                        loop={true}
                        watchSlidesProgress={true}
                        watchOverflow={true}
                        slidesPerView={1}
                        spaceBetween={30}
                        breakpoints={{
                            630: { slidesPerView: 2 },
                            991: { slidesPerView: 3 },
                        }}
                    >
                        {repeatable_entry.map((entry, index) => (
                            <SwiperSlide key={index}>
                                <div className="snippet-link-box-carousel__entry">
                                    <img
                                        className="snippet-link-box-carousel__entry-image"
                                        loading="lazy"
                                        height="290"
                                        width="290"
                                        src={entry.image?.value}
                                        alt={entry.alt?.value ?? ''}
                                    />
                                    <div className="snippet-link-box-carousel__entry-container-content">
                                        <SnippetLink
                                            linkStyles={entry.linkStyle?.value}
                                            className="snippet-link-box-carousel__entry-link"
                                            url={entry.linkHref?.value}
                                            openInNewTab={entry.linkTarget?.value}
                                        >
                                            {entry.linkText?.value}
                                        </SnippetLink>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    )
}

export default SnippetLinkBoxCarousel
